import { LocationState } from "../location/locationModels";

export interface DeliveryState {
  getDeliveryChargeLoading: boolean;
  getDeliveryChargeFailed: boolean;
  getDeliveryChargeSuccess: boolean;
  deliveryQuotationDetails: DeliveryQuotationDetails | null;
  getDunzotrackingLoading: boolean;
  getDunzotrackingFailed: boolean;
  getDunzotrackingSuccess: boolean;
  dunzoTrackingDetails: DunzoTrackingDetails | null;

  // Instore Valet app tracking
  getValetLocationLoading: boolean;
  getValetLocationSuccess: boolean;
  getValetLocationFailure: boolean;
  valetLocation: LocationState | null;
}

export interface DeliveryCharge {
  pickupDetails: LocationDetails;
  dropDetails: LocationDetails;
  deliveryProviderId: string;
  receiverDetails: userData;
  senderDetails: userData;
  customerId?: string;
  addressId?: string;
  tip?:any;
  locationId:string;
  orderTotal?: string | number;
  emailId?: string;
  mobileNo?: string;
}
export interface getDeliveryDetails {
  orderId: string | null;
  DeliveryProviders: string | null;
  emailId?: string;
  mobileNo?: string;
}
export interface DeliveryChargeRequestBody {
  locationId :string;
  pickupDetails: LocationDetails;
  dropDetails: LocationDetails;
  locationProviderId?: string;
  deliveryProviderId?: string;
  receiverDetails: userData;
  senderDetails: userData;
  customerId?: string;
  addressId?: string;
  tip?:any
  orderTotal?: string | number;
  emailId?: string;
  mobileNo?: string;
}

export interface userData {
  name: string;
  phoneNumber: string;
}
export interface DeliveryQuotationDetails {
  estimatedPrice: string;
  eta: LocationDetails;
}
const DunzoOrderDeliveryStatusTypes = [
  "cancelled",
  "created",
  "queued",
  "runner_accepted",

  "delivered",
  "reached_for_delivery",

  "reached_for_pickup",
  "pickup_complete",
  "started_for_delivery",

  "runner_cancelled",
] as const;

export type DunzoOrderDeliveryStatus =
  (typeof DunzoOrderDeliveryStatusTypes)[number];
export interface DunzoTrackingDetails {
  taskId: string;

  state: DunzoOrderDeliveryStatus;
  eventTimestamp: number;
  eta: {
    pickup: number | null;
    dropoff: number | null;
  };
  runner: {
    name: string;
    phoneNumber: string | null;
    location: {
      address: null;
      lat: number;
      lng: number;
    };
  };
  requestTimestamp: number;
  trackingUrl: string | null;
  price: string | null;
  totalTime: null;
  codAmountCollected: null;
}

export interface LocationDetails {
  lat: number;
  lng: number;
  Address: addressDetails;
}
export interface addressDetails {
  streetAddress1: string | null;
  streetAddress2: string | null;
  city: string | null;
  state: string | null;
  pincode: string | null;
}

export const DeliveryProviders = {
  DUNZO: "DUNZO",
  SHADOWFAX: "SHADOWFAX",
  SIMPERY: "SIMPERY",
  DOORDASH: "DOORDASH",
  /**
   * Burq.
   *
   * The value matches `mh_location_delivery_providers.delivery_provider_id`
   * exactly, because the Java gateway resolves its provider with
   * `DeliveryServiceProviders.valueOf(column)` and throws on anything it does
   * not recognise. Quoting for a Burq location goes to maghil-backend-v3
   * rather than the gateway — see `getBurqDeliveryQuoteAPI`.
   */
  BURQ: "BURQ_PROVIDER"
};
